export default {"src":"/_next/static/media/15-icon.7c0538a2.svg","height":35,"width":46,"blurWidth":0,"blurHeight":0};